import React from 'react'

import {
  ColorScheme,
  TcolorScheme
} from '~/experiments/color-scheme/ColorScheme'
import { styled } from '~/styled'

export const StyledTile = styled(
  'div',
  {
    base: [
      'box-border',
      'flex',
      'flex-col',
      'relative',
      'border',
      'bg-(--base-1)',
      'text-(--foreground)',
      'border-transparent'
    ],
    variants: {
      borderRadius: {
        sm: ['rounded-sm'],
        md: ['rounded-md'],
        lg: ['rounded-xl']
      },
      border: {
        true: ['border-(--base-3)']
      },
      diffused: {
        true: [
          'supports-color-mix:bg-[color-mix(in_hsl,(--base-1)_70%,transparent)]',
          'supports-color-mix:backdrop-blur-sm'
        ]
      }
    }
  },
  { enabledResponsiveVariants: true }
)

type TTileProps = React.ComponentProps<typeof StyledTile> & {
  colorScheme?: TcolorScheme
}

export const Tile = React.forwardRef<HTMLDivElement, TTileProps>(
  ({ children, borderRadius = 'lg', colorScheme = {}, ...rest }, ref) => (
    <ColorScheme
      asChild
      base="grey1"
      accent="primary2"
      interactive="loContrast"
      {...colorScheme}
    >
      <StyledTile ref={ref} borderRadius={borderRadius} {...rest}>
        {children}
      </StyledTile>
    </ColorScheme>
  )
)

Tile.displayName = 'Tile'
